<template>
	<div>
		<el-form :inline="true" size="mini" :model="pages" :class="lang=='cn'?'':'on'">
			<el-form-item :label="$t('course_index.date')" prop="date" data-name="日期">
				<el-date-picker v-model="pages.date" style="width:250px" clearable value-format="timestamp" type="daterange" :range-separator="$t('course_index.range')" :start-placeholder="$t('course_index.startdate')" :end-placeholder="$t('course_index.enddate')"></el-date-picker>
			</el-form-item>
			<el-form-item :label="$t('course_index.age')" prop="age" data-name="年龄">
				<el-select v-model="pages.age" style="width:120px" clearable :placeholder="$t('index.select')">
					<el-option v-for="(item,index) in age" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="item.code"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item :label="$t('course_index.teacher')" prop="teacher_id" data-name="老师">
				<el-select v-model="pages.teacher_id" style="width:120px" filterable clearable class="w100" :placeholder="$t('index.select')">
					<el-option v-for="(item,index) in teacher" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="item.teacher_id"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item :label="$t('course_index.theme')" prop="keyword" data-name="主题">
				<el-input v-model="pages.keyword" :placeholder="$t('index.pleaseInput')"></el-input>
			</el-form-item>
			<el-form-item label="ID" prop="ID" data-name="id">
				<el-input v-model="pages.id" style="width:90px" :placeholder="$t('index.pleaseInput')"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" size="mini" @click="search()">{{$t('index.search')}}</el-button>
				<el-button type="primary" size="mini" @click="reset()">{{$t('index.reset')}}</el-button>
			</el-form-item>
		</el-form>
		<el-table :data="list" size="mini" border>
			<el-table-column prop="id" align="center" label="ID" data-name="id" width="50"></el-table-column>
			<el-table-column :prop="lang=='cn'?'theme_cn':'theme'" align="center" :label="$t('course_index.theme')" data-name="主题" min-width="120"></el-table-column>
			<el-table-column prop="teacher_id" align="center" :label="$t('course_index.teacher')" data-name="老师">
				<template slot-scope="{row}">{{filters_list(row.teacher_id,teacher,'teacher_id','name')}}</template>
			</el-table-column>
			<el-table-column prop="start_date" align="center" :label="$t('course_index.date')" data-name="日期" width="190">
				<template slot-scope="{row}">{{getTime_us(row.start_date,'mmddyyyy')}} ~ {{getTime_us(row.end_date,'mmddyyyy')}}</template>
			</el-table-column>
			<el-table-column prop="start_time" align="center" :label="$t('course_index.time')" data-name="时间" width="140">
				<template slot-scope="{row}">{{getTime_us(row.start_time,'hh:ii')}} ~ {{getTime_us(row.end_time,'hh:ii')}}</template>
			</el-table-column>
			<el-table-column prop="surplus" align="center" :label="$t('course_index.max_people')" data-name="班级规模" width="100">
				<template slot-scope="{row}">{{row.student_num}}/{{row.max_people}}</template>
			</el-table-column>
			<el-table-column prop="min_age" align="center" :label="$t('course_index.age')" data-name="年龄" width="100">
				<template slot-scope="scope">{{scope.row.min_age}}-{{scope.row.max_age}}y</template>
			</el-table-column>
			<el-table-column prop="sort" align="center" :label="$t('course_index.sort_sort')" width="120" data-name="排序" v-if="select==0">
				<template slot-scope="{row}">
					<el-input-number size="mini" controls-position="right" v-model="row.sort" class="w100" @change="sortHandleChange(row,row.sort)" :min="0"></el-input-number>
				</template>
			</el-table-column>
			<el-table-column :label="$t('index.operation')" align="center" fixed="right" :width="150">
				<template slot-scope="{row}">
					<el-button size="mini" type="primary" v-if="select==0" @click="id=row.id,isdialog=true">{{$t('course_index.student_list')}}</el-button>
					<el-button size="mini" type="primary" v-if="select==1" @click="click_select(row)">{{$t('index.select')}}</el-button>
				</template>
			</el-table-column>
		</el-table>
		<pagination :total="pages.count" :page.sync="pages.page" :limit.sync="pages.perpage" @pagination="init" />
		<teacher_student_list :isdialog="isdialog" :id="id" @guanbitanchu="function(e){isdialog=false}"></teacher_student_list>
	</div>
</template>
<script>
import teacher_student_list from '@/components/teacher_student_list_inventory.vue'
export default {
	components: {
		teacher_student_list
	},
	data() {
		return {
			list: [],
			pages: {
				date:[],
				age:'',
				teacher_id:'',
				keyword:'',
				id:'',
				page: 1,
				count: 0,
				perpage: 50,
			},
			teacher:[],
			age:[],
			id:0,
			isdialog:false,
		}
	},
	props:{
		select: {
			type:Number,
			default:0
		},
		perpage: {
			type:Number,
			default:20
		},
	},
	// 初始事件
	mounted: function () {
		this.pages.perpage = this.perpage;
		this.config();
		this.init();
	},
	// 事件
	methods: {
		config() {
			this.$post('courseScreen', {}).then((res) => {
				this.age=res.age;
				this.teacher=res.teacher;
			})
		},
		// 初始化
		init: function () {
			var this_ = this;
			var url = "courseIndex"
			var datas = {
				...this.pages,
				num: this.pages.perpage,
				is_hide:1
			}
			if (this.pages.date.length>0) {
				datas['start_date']=this.pages.date[0]/1000;
				var time=(24*60*60-1)*1000;
				datas['end_date']=(this.pages.date[1]+time)/1000;
			}
			this.$post(url, datas).then((res) => {
				this.list = res.list;
				this.pages.count = res.sum;
			})
		},
		// 搜索
		search() {
			this.pages.page = 1;
			this.init();
		},
		// 重置
		reset() {
			this.pages = this.$options.data().pages;
			this.init();
		},
		filters_list(value,list,id,name){
			for (var i = list.length - 1; i >= 0; i--) {
				if(list[i][id]==value){
					return this.lang=="cn"?list[i][name+'_cn']:list[i][name];
				}
			}
		},
		sortHandleChange(data,value){
			var url = "changeField";
			var datas = {
				pk_id: data.id,
				table:'course',
				field:'sort',
				value:value,
			};
			this.$post(url, datas).then((res) => {
				this.$message.success(this.$t('index.operation_success'));
				this.init();
			})
		},
		click_select(data){
			this.$emit("callback",data);
		},
	},
	// 过滤器
	filters: {
	}
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/change_courses.vue